export default __webpack_public_path__ + "static/media/order-fulfillment-banner.d8b97cbf.png";